import React from 'react';
import { FormattedMessage } from 'react-intl';

class EmptyFav extends React.PureComponent{
  render() {
    return(
      <div className="empty list-item">
        <img src={require('../../../images/placeholder-my-pick.jpg')} />
        <div className="item-info">
          <h3 className="item-title empty-title">myPick</h3>
          <FormattedMessage id="mypick-text">
            {(message) => <p className="empty-text">{message}</p>}
          </FormattedMessage>
        </div>
      </div>
    );
  }
}

export default EmptyFav;




/** WEBPACK FOOTER **
 ** ./src/components/restaurant/core/EmptyFav.js
 **/